import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

// Components

import IncomeInformationSummary from './pageIncludes/summary/IncomeInformationSummary';
import PageHeader from '../headers/PageHeader';



const Page3_37_E1 = props => {
    const {
        data,
        data: {
            coverageYear,
            taxHousehold
        },
        environment: {
            isState
        },
        householdMembers
    } = props;

    const {
        buttonContainer,
        isUnemploymentIncomeAttestationEnabled,
        itfFeatureEnabled,
        pageName
    } = props;

    return (
        <Fragment>
            <div id="incomeSummary" className="fade-in">
                <div className="subsection">
                    <PageHeader
                        text='ssap.subheader.review_and_confirm'
                        headerClassName={'gi-heading-alt'}
                    />
                    <div className="grid-row">
                        <div className="usa-alert usa-alert--info gi-alert gi-alert__info">
                            <div className="usa-alert__body gi-alert__info__body">
                                <p className="usa-alert__text gi-alert__info__text">
                                    <FormattedMessage 
                                        id='ssap.income_information.summary.household_income'
                                        values={{
                                            strong: chunks => <strong>{chunks}</strong>
                                        }}
                                    />
                                </p>
                            </div>
                        </div>
                    </div>

                    <IncomeInformationSummary
                        {...{
                            buttonContainer,
                            coverageYear,
                            householdMembers,
                            isState,
                            isUnemploymentIncomeAttestationEnabled,
                            itfFeatureEnabled,
                            pageName,
                            previousData: data,
                            taxHousehold
                        }}
                    />
                </div>
            </div>
        </Fragment>
    );
};

const mapStateToProps = state => ({
    environment: state.common.environment,
    data: state.ssap.data,

    householdMembers: state
        .ssap
        .data
        .taxHousehold
        .householdMember,
});

export default connect(mapStateToProps)(Page3_37_E1);
